/********* --- Mobile Navigation --- *********/
class MobileNavigationSection extends BTSection {
  hasOpenedSidebarMenu() {
    return $('body').hasClass('open-sidebar-canvas--sidebar-mobile-nav');
  }

  openSidebarMenu() {
    if(!this.hasOpenedSidebarMenu() && BT.data.cacheWindowWidth <= BT.options.windowScreen.mobile) {
      $('.mobile-nav-bar').trigger('click');
    }
  }

  closeSidebarMenu() {
    $('#sidebar-mobile-nav .bt-sidebar__close').trigger('click');
  }

  getTopEle(ele) {
    return ele.hasClass('mobile-nav__item') ? ele : ele.parents('.mobile-nav__item');
  }

  toggleSubItem(ele, action) {
    var topEle = this.getTopEle(ele);
    if(topEle.hasClass('mobile-nav__item--parent')) {
      if(!ele.hasClass('mobile-nav__item--parent') && ((action == 'open' && !topEle.hasClass('open')) || (action == 'close' && topEle.hasClass('open')))) {
        topEle.find('.mobile-nav__top-link-wrap .mobile-nav__arrow').trigger('click');  
      }
    }
  }

  onSelect(evt) {
    if(BT.data.cacheWindowWidth > BT.options.windowScreen.mobile) {
      BT.showNotify('Please adjust to the mobile screen to see the changes.', BT.options.notifyClassTypes.danger);
    } else {
      this.openSidebarMenu();
    }
  }

  onDeselect(evt) {
    this.closeSidebarMenu();
  }

  onBlockSelect(evt) {
    this.openSidebarMenu();
    var ele = $(evt.target);
    this.toggleSubItem(ele, 'open');
  }

  onBlockDeselect(evt) {
    var ele = $(evt.target);
    this.toggleSubItem(ele, 'close');
  }
}
theme.sections.constructors['navigation-mobile'] = MobileNavigationSection;
